
interface ErrorFallbackProps {
  error: Error
  resetError?: () => void
}

const ErrorFallback = ({ error, resetError }: ErrorFallbackProps) => {

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-red-500 mb-4">错误</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            应用遇到了一个问题
          </h2>
          <p className="text-gray-600 mb-6">
            抱歉，应用运行时发生了错误。我们已经记录了这个问题。
          </p>

          <div className="flex gap-4 justify-center">
            {resetError && (
              <button
                onClick={resetError}
                className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
              >
                重试
              </button>
            )}
            <button
              onClick={() => window.location.href = '/home'}
              className="px-6 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
            >
              返回首页
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorFallback